module.exports = __webpack_public_path__ + "img/cafeamplatzallergielogo.41adcc2e.png";